(() => {
  if (window.galixHowMotion) return;
  const selector = '[data-how-motion]';
  const clamp = value => Math.max(0, Math.min(1, value));

  function init(section) {
    if (section.galixHowController) return;
    const steps = [...section.querySelectorAll('[data-how-step]')];
    if (!steps.length) return;
    const controller = new AbortController();
    const { signal } = controller;
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    let visible = false;
    let entered = false;
    let frame = 0;
    let animations = [];
    section.galixHowController = controller;
    section.dataset.howReady = 'true';

    function paint() {
      frame = 0;
      if (signal.aborted) return;
      const rect = section.getBoundingClientRect();
      const progress = reduced.matches ? 1 : clamp((innerHeight * .85 - rect.top) / Math.max(1, rect.height * .65));
      section.style.setProperty('--how-progress', progress.toFixed(4));
      section.dataset.howProgress = progress.toFixed(4);
      steps.forEach((step, index) => step.classList.toggle('is-lit', progress >= index / steps.length));
    }
    function schedule() {
      if (visible && !frame && !signal.aborted && !document.hidden) frame = requestAnimationFrame(paint);
    }
    function cancelAnimations() {
      animations.forEach(animation => animation.cancel());
      animations = [];
    }
    function enter() {
      if (entered || reduced.matches || document.hidden) return;
      entered = true;
      const distance = innerWidth <= 600 ? 12 : 24;
      steps.forEach((step, index) => {
        const img = step.querySelector('img');
        if (!img?.animate) return;
        const animation = img.animate([
          { transform: `translateY(${distance}px) scale(.96)`, opacity: .55 },
          { transform: 'translateY(0) scale(1)', opacity: 1 }
        ], { duration: 720, delay: index * 130, easing: 'cubic-bezier(.22,1,.36,1)', fill: 'backwards' });
        animations.push(animation);
      });
    }
    const observer = new IntersectionObserver(entries => {
      visible = entries[0].isIntersecting;
      if (visible) { enter(); schedule(); }
      else { cancelAnimationFrame(frame); frame = 0; }
    }, { threshold: .15 });
    const resizeObserver = new ResizeObserver(schedule);
    observer.observe(section);
    resizeObserver.observe(section);
    window.addEventListener('scroll', schedule, { passive: true, signal });
    window.addEventListener('resize', schedule, { passive: true, signal });
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) { cancelAnimations(); cancelAnimationFrame(frame); frame = 0; }
      else schedule();
    }, { signal });
    reduced.addEventListener('change', () => {
      cancelAnimations();
      cancelAnimationFrame(frame); frame = 0;
      paint();
    }, { signal });
    signal.addEventListener('abort', () => {
      observer.disconnect(); resizeObserver.disconnect();
      cancelAnimationFrame(frame); cancelAnimations();
      steps.forEach(step => step.classList.remove('is-lit'));
      section.style.removeProperty('--how-progress');
      delete section.dataset.howReady;
      delete section.dataset.howProgress;
      delete section.galixHowController;
    }, { once: true });
    paint();
  }
  function mount(root = document) {
    if (root.matches?.(selector)) init(root);
    root.querySelectorAll(selector).forEach(init);
  }
  window.galixHowMotion = { mount };
  document.addEventListener('shopify:section:load', event => mount(event.target));
  document.addEventListener('shopify:section:unload', event => {
    if (event.target.matches?.(selector)) event.target.galixHowController?.abort();
    event.target.querySelectorAll(selector).forEach(section => section.galixHowController?.abort());
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount(), { once: true });
  else mount();
})();
